import { Button, ConfigProvider, Select, Space, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { getTranslatedText } from '../../../services/apps/plugins';
import { usePluginStore } from '../../../store/RootStoreContext';
import { grispiNotification } from '../../../store/useNotificationStore';
import { fireReplaceTextToRichTextEditorStateEvent } from '../../GrispiRichTextEditor/plugins/ReplaceTextPlugin';

const TranslateApp = ({
    eventListenerKey,
    apiKey,
    commentText,
    languageOptions
}: {
    eventListenerKey?: string;
    apiKey: string;
    commentText: string;
    languageOptions: any;
}) => {
    const { t } = useTranslation('common');

    const { setTargetLanguage, targetLanguage } = usePluginStore();

    return (
        <>
            <ConfigProvider theme={{ token: { fontSize: 12 }, inherit: true }}>
                <Space>
                    <Typography.Text>{t('plugin.translate.translateTo')}</Typography.Text>
                    <Select
                        style={{ width: '150px' }}
                        options={languageOptions ? (languageOptions as any[]) : null}
                        value={targetLanguage}
                        onChange={(value) => setTargetLanguage(value)}
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                            (option?.label ?? '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'))
                        }
                    />
                    <Button
                        type="text"
                        disabled={commentText ? false : true}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (commentText)
                                getTranslatedText(apiKey, commentText, targetLanguage)
                                    .then((trans) => {
                                        fireReplaceTextToRichTextEditorStateEvent({
                                            eventListenerKey,
                                            textToReplace: trans
                                                ?.map((translation) => {
                                                    return translation.translatedText;
                                                })
                                                .join('-')
                                        });
                                    })
                                    .catch((error) => grispiNotification('error', error, 'error'));
                        }}
                    >
                        {t('plugin.translate.translateButtonText')}
                    </Button>
                </Space>
            </ConfigProvider>
        </>
    );
};

export default observer(TranslateApp);
